export default __webpack_public_path__ + "static/media/gt5.c1ce779c.png";